import React from "react";
import { UserDeviceActivityContentCellTemplate } from "themes/administration/analytics/components";

function UserDeviceActivityContentCell(props) {
    return <UserDeviceActivityContentCellTemplate {...props} />;
}

export default UserDeviceActivityContentCell;
